import * as React from "react";
import cx from "classnames";

export interface NextStepProps {
  goToNextStep: React.EventHandler<any>;
  disabled?: boolean;
}

const getMainClasses = ({ disabled }: NextStepProps) =>
  cx("wizard-footer__next-step", {
    "wizard-footer__next-step--disabled": disabled,
  });

const NextStep = (props: NextStepProps) => (
  <button
    className={getMainClasses(props)}
    onClick={props.disabled ? f => f : props.goToNextStep}
  >
    <span className="hidden-xs">Tiếp theo</span>
    <i className="fa wizard-footer__nav-icon fa-caret-right" />
  </button>
);

export default NextStep;



// WEBPACK FOOTER //
// ./src/routes/Wizard/components/NextStep.tsx